module.exports = __webpack_public_path__ + "static/media/29DUNON4.f6c7ace9.jpg";